import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, process } from '@progress/kendo-data-query';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { ApiService } from 'src/app/services/http/api.service';
import { Inventory } from 'src/app/models/inventory.model';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { images } from 'src/app/resources/images';
import { Locker } from 'src/app/models/locker.model';

@Component({
    selector: 'app-inventory-component',
    templateUrl: './inventory.component.html'
})
export class InventoryComponent implements OnInit {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public gridData: Inventory[] = [];
    public gridView: any[] = [];
    public filter: CompositeFilterDescriptor | undefined;
    public mySelection: string[] = [];
    public customMsgService: CustomMessagesService;
    public listLocal: Array<any> = [];
    public listArmario: Array<Locker> = [];
    public local: any;
    public armario: any;
    public placeHolder: any = {
        nome: "",
        id: undefined,
    };
    public escolherArmario: any = {
        nome: "",
        id: undefined,
    };
    constructor(public msgService: MessageService, private api: ApiService, private notificationService: NotificationService) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.allData = this.allData.bind(this);
        this.placeHolder.nome = this.customMsgService.translate('escolherLocal');
        this.escolherArmario.nome = this.customMsgService.translate('escolherArmario');
    }

    ngOnInit(): void {
        this.load();
    }

    load() {
        this.gridView = this.gridData;
        this.api
            .getRequest<BaseHttpResponse<Inventory[]>>("Inventario/GetInventario")
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => { });
        this.api
            .getRequest<BaseHttpResponse<any>>("Local/GetLocais")
            .then((data) => {
                this.listLocal = data.value;
            })
            .catch((err) => { });
        this.api
            .getRequest<BaseHttpResponse<Locker[]>>("Armario/GetArmarios")
            .then((data) => {
                this.listArmario = data.value;
            })
            .catch((err) => { });
    }

    public pesquisar() {
        let idLocal = this.local.id;
        let idarmario = this.armario.id;
        let uri = "";
        if (idLocal == undefined) {
            uri = "Inventario/GetInventario?idArmario=" + idarmario;
        }
        else if (idarmario == undefined) {
            uri = "Inventario/GetInventario?idLocal=" + idLocal
        }
        else if (idLocal == undefined && idarmario == undefined) {
            uri = "Inventario/GetInventario"
        }
        else {
            uri = "Inventario/GetInventario?idLocal=" + idLocal + "&idArmario=" + idarmario
        }
        this.api
            .getRequest<BaseHttpResponse<Inventory[]>>(uri)
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => { });
    }

    public onTeamChange(pageSize: number): void {
        pageSize === 25
            ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
            : (this.gridView = this.gridData.slice(0, pageSize));
    }

    public onFilter(inputValue: string): void {
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: inputValue
                    }
                ]
            }
        }).data;

        this.dataBinding ? this.dataBinding.skip = 0 : null;
    }
    public getField = (args: Inventory) => {
        return `${args.codigoInterno}_${args.codigoFabricante}_${args.nomeArtigo}_${args.nomeLocal}_${args.nomeArmario}`;
    }

    public allData(): ExcelExportData {
        const result: ExcelExportData = {
            data: process(this.gridView, { filter: this.filter }).data,
        };

        return result;
    }

    //data atual
    getdatetime() {
        var today = new Date();
        var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        var dateTime = date + ' ' + time;
        return dateTime;
    }

    public photoURL(dataItem: any): string {
        const code: string = dataItem.imgId;
        const image: any = images;

        return image[code];
    }

    public flagURL(dataItem: any): string {
        const code: string = dataItem.country;
        const image: any = images;

        return image[code];
    }

}
